import { ChangeDetectionStrategy, Component, HostListener, computed, input, output, signal } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-custom-id',
    templateUrl: './web-custom-id.component.html',
    styleUrls: ['./web-custom-id.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TooltipModule, CdkCopyToClipboard, TranslateModule],
})
export class WebCustomIdComponent {
    public readonly displayId = input<string>('');
    public readonly disabled = input<boolean>(false);
    public readonly valueChangeEvent = output<string>();

    public readonly isEditing = signal(false);
    public readonly editedId = signal('');
    public readonly isEditedIdEmpty = computed(() => !this.editedId());

    public editId(): void {
        if (this.disabled()) return;
        this.editedId.set(this.displayId() ?? '');
        this.isEditing.set(true);
    }

    public setEditedId(event: Event): void {
        this.editedId.set((event.target as HTMLInputElement).value);
    }

    public saveId(): void {
        this.valueChangeEvent.emit(this.editedId().replaceAll(' ', '_'));
        this.isEditing.set(false);
    }

    public cancelChangeId(): void {
        this.isEditing.set(false);
    }

    @HostListener('document:keydown.enter')
    public onEnter(): void {
        if (this.isEditing()) {
            this.saveId();
        }
    }

    @HostListener('document:keydown.escape', ['$event'])
    public onEscape(event: KeyboardEvent): void {
        if (!this.isEditing()) {
            return;
        }

        event.stopPropagation();
        this.cancelChangeId();
    }
}
